import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body, Typography } from "../styled";
import { format, formatISO } from "date-fns";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const GeneralData: FC = () => {
  return (
    <Box mt={1}>
        <Header>
            <Typography
                ml={2}
                mb={1}
            >
                !!!Раздел заполняется только при смене ФИО или паспортных данных
            </Typography>
            <TextField
                label="Фамилия"
                variant="outlined"
                size="small"
                sx={{ mb: 1, width: "500px" }}
            />
            <TextField
                label="Имя"
                variant="outlined"
                size="small"
                sx={{ mb: 1, width: "500px" }}
            />
            <TextField
                label="Отчество"
                variant="outlined"
                size="small"
                sx={{ mb: 1, width: "500px" }}
            />
            <TextField
                label="Дата изменения"
                value={format(1683886255004, "dd.MM.yyyy")}
                variant="outlined"
                size="small"
                sx={{ width: "200px", mb: 1 }}
            />
        </Header>
        <Body>
            <Typography
                ml={2}
                mb={1}
            >
                Документ, удостоверяющий личность
            </Typography>
            <Box display='flex'>
                <TextField
                    label="Документ, удостоверяющий личность(паспорт)"
                    variant="outlined"
                    size="small"
                    sx={{ mr: 1, width: "500px" }}
                />
                <TextField
                    label="серия"
                    variant="outlined"
                    size="small"
                    sx={{ mr: 1, width: "200px" }}
                />
                <TextField
                    label="номер"
                    variant="outlined"
                    size="small"
                    sx={{ mr: 1, mb: 1, width: "200px" }}
                />
            </Box>
            <TextField 
                    label="Кем выдан"
                    variant="outlined"
                    size="small"
                    sx={{ width: "800px", mb: 1 }}
                />
            <Box display='flex'>
                <TextField
                    label="Дата выдачи"
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
                <TextField
                    label="Подразделение"
                    variant="outlined"
                    size="small"
                    sx={{width: "200px",mb: 1 }}
                />
            </Box>
        </Body>
    </Box>
  );
};

export default GeneralData;
